import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';

var ExecutionResult = function () {
    function ExecutionResult(code, data) {
        _classCallCheck(this, ExecutionResult);

        this.retCode = code;
        if (data !== null) {
            this.retData = data;
        }
    }

    _createClass(ExecutionResult, [{
        key: 'isSuccessful',
        value: function isSuccessful() {
            return this.retCode === '000000';
        }
    }]);

    return ExecutionResult;
}();

export default ExecutionResult;